import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Paper from "@material-ui/core/Paper";
import FrameAppBar from "./FrameAppBar";
import QuotePage from "./QuotePage";
import { GetHTMLColour, BaseURL } from "../../components/Common";
import { updateJobState, updateDistributor, updateJobUser } from "../../redux_store/jobState";
import QuotePageEditExtras from "./QuotePageEditExtras";
import { MANUFACTURER } from "../../AppConfig";
import { engineeringPassed } from "../../redux_store/jobState_Validation";

export default (props) => {
    const dispatch = useDispatch();
    const job = useSelector((state) => state.job);
    const user = useSelector((state) => state.app.user);
    let manufacturer = useSelector((state) => state.app.manufacturer);
    const { toggleQuoteOpen } = props;
    const [showEditExtraItems, setShowEditExtraItems] = React.useState(false);

    if (window.LYSAGHT) manufacturer = { ...MANUFACTURER.Lysaght, Logo: BaseURL(MANUFACTURER.Lysaght.Logo) };

    const updateJobStateDelegate = (section, parameter, value) => {
        dispatch(updateJobState(section, parameter, value));
    };

    const updateDistributorDelegate = (value) => {
        dispatch(updateDistributor(value));
    };

    const updateUserDelegate = (value) => {
        dispatch(updateJobUser(value));
    };

    let { engValid, MaxResultsText } = engineeringPassed({ job });

    return (
        <Paper
            elevation={20}
            style={{ width: "100%", height: "100%", background: "#CCC", display: "flex", flexDirection: "column" }}
        >
            {engValid ? (
                <FrameAppBar
                    title={"Quote for #" + job.id}
                    onClick={toggleQuoteOpen}
                    button1Text="CREATE PDF for Printing or Emailing"
                    button1Click={props.toggleGenerateQuoteAndDocumentOpen}
                />
            ) : (
                <FrameAppBar
                    title={"Quote for #" + job.id}
                    onClick={toggleQuoteOpen}
                    text1={
                        <p
                            style={{
                                color: "red",
                                fontWeight: "bold",
                                backgroundColor: "white",
                                padding: "10px",
                                borderRadius: "10px",
                            }}
                        >
                            Engineering Failed. Cannot Print
                        </p>
                    }
                />
            )}

            <div
                style={{
                    overflow: "auto",
                    flex: 1,
                }}
            >
                <QuotePage
                    job={job}
                    user={user}
                    manufacturer={manufacturer}
                    updateUser={updateUserDelegate}
                    updateJobState={updateJobStateDelegate}
                    updateDistributor={updateDistributorDelegate}
                    GetHTMLColour={GetHTMLColour}
                    setShowEditExtraItems={setShowEditExtraItems}
                    footer_text={"QUOTE LAYOUT | #" + job.id + " (" + job.Customer.JobName + ")"}
                    page_number={1}
                    brandRedirect={window.location.href.split("app/")[0] + "app?3d-viewer&job=" + job?.id}
                    print={false}
                />
            </div>
            <div style={{ width: "4px", background: "#CCC", cursor: "e-resize" }}></div>

            {showEditExtraItems && (
                <QuotePageEditExtras
                    open={showEditExtraItems}
                    job={job}
                    updateJobState={updateJobStateDelegate}
                    onClose={(total) => {
                        // if (total !== undefined && total !== null) setValues({ ...values, extra: total });
                        setShowEditExtraItems(false);
                    }}
                />
            )}
        </Paper>
    );
};